const config = {
  development: {
    FIREBASE_API_KEY: "AIzaSyBnX3gWAndUFDOHrQqp9Dh0NGuAPA8JPV8",
    FIREBASE_AUTH_DOMAIN: "trendaro-v2-dev2.web.app",
    FIREBASE_DATABASE_URL: "https://minute-dev.firebaseio.com",
    FIREBASE_PROJECT_ID: "minute-dev",
    FIREBASE_STORAGE_BUCKET: "minute-dev.appspot.com",
    FIREBASE_MESSAGING_SENDER_ID: "967317112807",
    FIREBASE_APP_ID: "1:967317112807:web:35df7d000c074e4c911f42",
    FIREBASE_VAPID_KEY:
      "BPMPH0Y66YX27pgaJ9rVXEFssxeuvDzct5hZ7Ezy4Y02wlb7PlB45j32rM6TI1a0AeMJKhQaMg8OXk0NhTttXZg",
    APP_NAME: "DEV - Trendaro",
    SENTRY_URL: "",

    // Better Stack ingests errors over the Sentry protocol, so it is a second
    // DSN rather than a second SDK. Empty means Sentry only. Read it from the
    // Ingest tab as https://<application-token>@<ingesting-host>/<application-id>.
    // https://betterstack.com/docs/errors/collecting-errors/sentry-sdk/
    BETTER_STACK_SENTRY_URL: "",
    CDN_URL: "https://minute-cdn-dev.imgix.net",
    BUCKET_URL: "",
    CLOUDFLARE_URL: "https://customer-9ahnq69tzs27hc88.cloudflarestream.com",
    // Firebase Realtime Database Rest API URL
    RTDB_API_URL: "https://minute-dev.firebaseio.com",
    TRENDARO_API_URL: "https://api2-devel.trendaro.cz/v1",
    GOOGLE_ANALYTICS_ID: "G-Z2E6HGQR7L",
    GOOGLE_ANALYTICS_DEBUG_MODE: true,

    // Maintenance mode is used to disable the app for users.
    MAINTENANCE_MODE: false,

    // Disable registration using email link.
    // Registration using password and Google must be disabled in Firebase console.
    DISABLED_REGISTRATION: false,

    // This is used to restrict registration using password and email link to only to Behavio domain users,
    // and already registered users.
    // Enabled for public dev environment to avoid random registrations.
    RESTRICTED_REGISTRATION: true,
    RESTRICTED_REGISTRATION_DOMAIN: "behaviolabs.com",

    // Introsets follow the v3/v4 split like classic polls instead of staying
    // on v3 -- see resolvePollBasePath.
    INTROSET_FOLLOWS_SPLIT: true,
  },
  production: {
    FIREBASE_API_KEY: "AIzaSyDIVZBfE79VgbV3vCer4ByDVAM9NsCE47E",

    // Fallback only: hosts that serve /__/auth themselves use their own
    // hostname instead. See features/api/lib/auth-domain.ts.
    //
    // Deliberately unchanged by the #1102 cutover. This host serves /__/auth
    // either way -- Firebase Hosting today, the Worker's proxy afterwards --
    // so the value is right before and after, and pointing it elsewhere would
    // only reintroduce the cross-domain flow #1091 removed.
    FIREBASE_AUTH_DOMAIN: "moje.trendaro.cz",
    FIREBASE_DATABASE_URL: "https://minute-prod.firebaseio.com",
    FIREBASE_PROJECT_ID: "minute-prod",
    FIREBASE_STORAGE_BUCKET: "minute-prod.appspot.com",
    FIREBASE_MESSAGING_SENDER_ID: "171565633499",
    FIREBASE_APP_ID: "1:171565633499:web:c566f465219ae56dde21fe",
    FIREBASE_VAPID_KEY:
      "BAEPWqFeECbBwPHCkOPreow7wnAGGzc29_9A_UqEYkanyNGbCbhIDzrVmjnDUStqMs5TgAdCzWZStYClxkIpVtM",
    APP_NAME: "Trendaro",
    SENTRY_URL:
      "https://e97511bd31c9b19210ce8e161c5cb2ca@o4508341593767936.ingest.de.sentry.io/4508341597372496",
    BETTER_STACK_SENTRY_URL:
      "https://HmNEVdH9kdoQwfE3owqCiGbQ@s2725801.eu-central-1a.betterstackdata.com/2725801",
    CDN_URL: "https://minute-cdn.imgix.net",
    BUCKET_URL: "",
    CLOUDFLARE_URL: "https://customer-9ahnq69tzs27hc88.cloudflarestream.com",
    // Firebase Realtime Database Rest API URL
    RTDB_API_URL: "https://minute-prod.firebaseio.com",
    TRENDARO_API_URL: "https://api2.trendaro.cz/v1",
    GOOGLE_ANALYTICS_ID: "G-7C7RZ1ZCE5",
    GOOGLE_ANALYTICS_DEBUG_MODE: false,

    // Maintenance mode is used to disable the app for users.
    MAINTENANCE_MODE: false,

    // Disable registration using email link.
    // Registration using password and Google must be diabled in Firebase console.
    DISABLED_REGISTRATION: false,

    // This is used to restrict registration using password and email link to only to Behavio domain users,
    // and already registered users.
    // Used for testing purposes on staging environment.
    RESTRICTED_REGISTRATION: false,
    RESTRICTED_REGISTRATION_DOMAIN: "behaviolabs.com",

    // Stage and prod build from this one block, so flipping this moves both
    // at once -- see resolvePollBasePath.
    INTROSET_FOLLOWS_SPLIT: true,
  },
};

export default config[process.env.NODE_ENV as keyof typeof config];
